// import Login from "./pages/Login";
import Login from "./pages/Login_copy";
import Dashboard from "./pages/Dashboard";
// import Register from "./pages/Register";
import Register from "./pages/Register";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PublicLayout from "./components/Layout/PublicLayout";
import Homepage from "./pages/Homepage";
import DashboardLayout from "./components/Layout/DashboardLayout";
import PricingPlans from "./pages/PricingPlans";
import Matches from "./pages/Matches";
import Successstories from "./pages/Successstories";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Profileview from "./pages/Profileview";
import PaymentSuccess from "./pages/PaymentSuccess";
import Storymodel from "./pages/Storymodel";
import ScrollToTop from "./pages/ScrollToTop";
import CreateStory from "./pages/CreateStory";
import Interest from "./pages/Interest";
import ForgotPassword from "./pages/ForgotPassword";
import Shortlisted from "./pages/Shortlisted";
import Termsandcondition from "./pages/Termsandcondition";
import ProtectedRoute from "./routes/ProtectedRoute";
import GPayPage from "./pages/GPayPage";
import PaymentUsers from "./pages/PaymentUsers";
import ProfileLists from "./pages/ProfileLists";
import PrivacyPolicy from "./pages/PrivacyPolicy";

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* PUBLIC PAGES → HEADER VISIBLE */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Homepage />} />
          <Route path="/login" element={<Login />} />
          {/* <Route path="/login" element={<Login1 />} /> */}
          <Route path="/register" element={<Register />} />
          <Route path="/matches" element={<Matches />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/pricing" element={<PricingPlans />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/matches" element={<Matches />} />
          <Route path="/successstories" element={<Successstories />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/profile/:id" element={<Profileview />} />
          <Route path="/story/:id" element={<Storymodel />} />
          <Route path="/interest" element={<Interest />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/shortlisted" element={<Shortlisted />} />
          <Route path="/termsandcondition" element={<Termsandcondition />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy/>} />
          <Route path="/gpaypage" element={<GPayPage/>} />
        </Route>

        {/* DASHBOARD → HEADER HIDDEN */}
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/create-story" element={<CreateStory />} />
            <Route path="/create-profile" element={<ProfileLists />} />
            <Route path="/payment-users" element={<PaymentUsers />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>

    // <Login
    //   onLoginSuccess={handleLoginSuccess}
    //   onSwitchToRegister={() => setPage("register")}
    // />
  );
}
